export default "https://cdn.questicon.mathletics.com/assets/images/Reasoning-R-243a4292a392b9681ffffd063d34c694.png";